// ButtonLanguage.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import clicksound from '../components/music/click.mp3';
import i18n from "i18next";
import indo from "../components/image/ind.png"
import enghlish from "../components/image/eng.png"


const ButtonLanguage = () => {
    const [showDropdown, setShowDropdown] = useState(false);

    const handleButtonClick = () => {
        const audio = new Audio(clicksound);
        audio.play();
        setShowDropdown(!showDropdown);
    };

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        setShowDropdown(false);
    };

    return (
        <div className="relative">
            <button
                className="language-button lg:w-14 lg:h-14 sm:w-10 sm:h-10"
                onClick={handleButtonClick}
            >
                <FontAwesomeIcon icon={faGlobe} className="sm:text-xl font-bold lg:text-2xl" />
            </button>
            {showDropdown && (
               <div className="dropdown-menu absolute right-0 mt-2 sm:w-36 lg:w-40 sm:w-28 bg-white rounded-md shadow-lg z-20">
               <button
                   className="block px-4 py-2 hover:bg-gray-100 w-full text-left flex items-center"
                   onClick={() => handleLanguageChange('en')}
               >
                   <img
                       src={enghlish}
                       alt="English"
                       className="w-6 h-auto mr-2 object-cover flex-shrink-0 max-w-full max-h-full"
                   />
                   <span className="text-sm lg:text-base">English</span>
               </button>
               <button
                   className="block px-4 py-2 hover:bg-gray-100 w-full text-left flex items-center"
                   onClick={() => handleLanguageChange('id')}
               >
                   <img
                       src={indo}
                       alt="Indonesia"
                       className="w-6 h-auto mr-2 object-cover flex-shrink-0 max-w-full max-h-full"
                   />
                   <span className="text-sm lg:text-base">Indonesia</span>
               </button>
           </div>           
            )}
        </div>
    );
};

export default ButtonLanguage;
